import { createSlice } from "@reduxjs/toolkit";

const confirmationSlice = createSlice({
    name : 'confirmation',
    initialState : {
       show : false,
       confirm : false,
       details : '',
       from : ''
    },
    reducers : {
        confirmAction(state) {
            state.confirm = true;
            state.show = false;
        },

        closeConfirmationAction(state) {
            state.confirm = false;
            state.details = '';
            state.from = '';''
        },

        closeConfirmationBox(state) {
            state.show = false;
            state.confirm = false;
            state.actionMethod = null;
        },

        showConfirmationBox(state, {payload}) {
            state.show = true;
            state.confirm = false;
            state.details = payload.details;
            state.from = payload.from;
        }
    },
});

export default confirmationSlice.reducer;
export const {confirmAction, showConfirmationBox, closeConfirmationBox, closeConfirmationAction} = confirmationSlice.actions;